import { SettingsApplications } from '@material-ui/icons';
import { SettingsActionTypes } from './constants';

export type SettingsAction =
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_ADD;
          payload: {
              data: any;
          };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_ADD_SUCCESS;
          payload: {
              message: string;
          };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_ADD_ERROR;
          payload: {
              error: string;
          };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_LIST;
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_LIST_SUCCESS;
          payload: {
              message: string;
          };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_LIST_ERROR;
          payload: {
              error: string;
          };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_UPDATE_FORCE;
          payload: {
              data: any;
          };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_UPDATE_FORCE_SUCCESS;
          payload: {
              message: string;
          };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_UPDATE_FORCE_ERROR;
          payload: {
              error: string;
          };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_DELETE;
          payload: {
              app_id: string;
          };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_DELETE_SUCCESS;
          payload: {
              message: string;
          };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_DELETE_ERROR;
          payload: {
              error: string;
          };
      };

export const settingsAppAdd = (data: any): SettingsAction => ({
    type: SettingsActionTypes.SETTINGS_APP_ADD,
    payload: data,
});
export const settingsAppAddSuccess = (message: string): SettingsAction => ({
    type: SettingsActionTypes.SETTINGS_APP_ADD_SUCCESS,
    payload: { message },
});
export const settingsAppAddError = (error: string): SettingsAction => ({
    type: SettingsActionTypes.SETTINGS_APP_ADD_ERROR,
    payload: { error },
});

export const settingsAppList = (): SettingsAction => ({
    type: SettingsActionTypes.SETTINGS_APP_LIST,
});
export const settingsAppListSuccess = (message: string): SettingsAction => ({
    type: SettingsActionTypes.SETTINGS_APP_LIST_SUCCESS,
    payload: { message },
});
export const settingsAppListError = (error: string): SettingsAction => ({
    type: SettingsActionTypes.SETTINGS_APP_LIST_ERROR,
    payload: { error },
});

export const settingsAppUpdateForce = (data: any): SettingsAction => ({
    type: SettingsActionTypes.SETTINGS_APP_UPDATE_FORCE,
    payload: data,
});
export const settingsAppUpdateForceSuccess = (message: string): SettingsAction => ({
    type: SettingsActionTypes.SETTINGS_APP_UPDATE_FORCE_SUCCESS,
    payload: { message },
});
export const settingsAppUpdateForceError = (error: string): SettingsAction => ({
    type: SettingsActionTypes.SETTINGS_APP_UPDATE_FORCE_ERROR,
    payload: { error },
});

export const settingsAppDelete = (app_id: string): SettingsAction => ({
    type: SettingsActionTypes.SETTINGS_APP_DELETE,
    payload: { app_id },
});
export const settingsAppDeleteSuccess = (message: string): SettingsAction => ({
    type: SettingsActionTypes.SETTINGS_APP_DELETE_SUCCESS,
    payload: { message },
});
export const settingsAppDeleteError = (error: string): SettingsAction => ({
    type: SettingsActionTypes.SETTINGS_APP_DELETE_ERROR,
    payload: { error },
});
